module.exports = __webpack_public_path__ + "img/minus-circle-solid.da296998.svg";